import React from 'react';
import { CustomPhoneInput } from '../../shared/PhoneInput';
import { URLInput } from '../../shared/URLInput';
import { CountrySelect } from '../../shared/CountrySelect';
import { CompanyRegistrationInput } from '../../shared/CompanyRegistrationInput';

interface CompanyDetails {
  company_name: string;
  website: string;
  country: string;
  contact_phone: string;
  address: string;
  postal_code: string;
  city: string;
  registration_number: string;
}

interface CompanyFormProps {
  companyDetails: CompanyDetails;
  setCompanyDetails: (details: CompanyDetails) => void;
}

export function CompanyForm({ companyDetails, setCompanyDetails }: CompanyFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="form-label">Company Name</label>
        <input
          type="text"
          required
          value={companyDetails.company_name}
          onChange={(e) => setCompanyDetails({ ...companyDetails, company_name: e.target.value })}
          className="form-input"
        />
      </div>

      <div>
        <label className="form-label">Website</label>
        <URLInput
          value={companyDetails.website}
          onChange={(value) => setCompanyDetails({ ...companyDetails, website: value })}
          required
        />
      </div>

      <div>
        <label className="form-label">Country</label>
        <CountrySelect
          value={companyDetails.country}
          onChange={(value) => setCompanyDetails({ ...companyDetails, country: value })}
          required
        />
      </div>

      <div>
        <label className="form-label">Phone Number</label>
        <CustomPhoneInput
          value={companyDetails.contact_phone}
          onChange={(value) => setCompanyDetails({ ...companyDetails, contact_phone: value || '' })}
          required
        />
      </div>

      <div>
        <label className="form-label">Address</label>
        <input
          type="text"
          required
          value={companyDetails.address}
          onChange={(e) => setCompanyDetails({ ...companyDetails, address: e.target.value })}
          className="form-input"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="form-label">Postal Code</label>
          <input
            type="text"
            required
            value={companyDetails.postal_code}
            onChange={(e) => setCompanyDetails({ ...companyDetails, postal_code: e.target.value })}
            className="form-input"
          />
        </div>
        <div>
          <label className="form-label">City</label>
          <input
            type="text"
            required
            value={companyDetails.city}
            onChange={(e) => setCompanyDetails({ ...companyDetails, city: e.target.value })}
            className="form-input"
          />
        </div>
      </div>

      <CompanyRegistrationInput
        country={companyDetails.country}
        value={companyDetails.registration_number}
        onChange={(value) => setCompanyDetails({ ...companyDetails, registration_number: value })}
        required
      />
    </div>
  );
}